import masters_of_alchemy_img from '../../../assets/images/masters_of_alchemy.png';
import styled from 'styled-components';

export const Wrapper = styled.div`
padding-top: 3rem;
margin-bottom: 3rem;
width: 100%;
max-width: 1640px;

  .hero-img {
    width: 100%;
    max-width: 800px;
    border-radius: var(--mid-border-radius);
    margin-bottom: 2rem;
  }

  .info-table {
    margin: 0 auto 2rem;
    border-collapse: collapse;
    font-size: 1.1rem;
  }
  .info-table td {
    padding: 0.4rem 1rem;
    text-align: left;
  }
  .info-table td:first-child {
    font-weight: bold;
    text-align: right;
    white-space: nowrap;
  }

  .flavour-text {
    max-width: 720px;
    margin: 0 auto 2rem;
    font-size: 1.1rem;
    line-height: 1.7;
    font-style: italic;
  }

  .description {
    max-width: 720px;
    margin: 0 auto 2rem;
    font-size: 1rem;
    line-height: 1.6;
  }
`

export const WingedGuard = () => {

  return (
    <Wrapper>
      <div className='lr-padded-container center-text'>
        <h1 style={{marginBottom: '25px'}}>The Collegium of the Winged Guard</h1>
        <hr style={{maxWidth: '200px', marginInline: 'auto'}}/>
      </div>

      <div className='lr-padded-container center-text'>
        <h2>Massive D&D 5e Epic!</h2>
        <p style={{fontSize: '1.2rem', marginBottom: '1.5rem'}}>Running 20 tables in the same hall! Storylines intersect between tables. Teams will mashup as events trigger.</p>
      </div>

      <div className='lr-padded-container center-text'>
        <p className='flavour-text'>
          Lorlorian has been ravaged by endless war with the cause of the conflict long forgotten. So, when peace is achieved it is cause for great celebration. A treaty has finally been signed between the warring nations and a Grand Ball is being held. You played a pivotal role in brokering peace and are now a Guest of Honor. The chandeliers gleam, the drinks flow freely, and for the first time in generations there's a genuine sense of joy in the air.
        </p>
        <p className='flavour-text'>
          But despite the revelry, something is off. Why does a nursery rhyme about the Winged Guard echo endlessly in your mind? Why does that strange mark on your arm feel like it's burning? And why does an overwhelming sense of doom cling to the celebration?
        </p>
      </div>

      <div className='lr-padded-container center-text'>
        <table className='info-table'>
          <tbody>
            <tr><td>System</td><td>D&D 5e</td></tr>
            <tr><td>Players</td><td>100 level 14 characters</td></tr>
            <tr><td>DMs</td><td>20</td></tr>
            <tr><td>Duration</td><td>3 hours</td></tr>
            <tr><td>When</td><td>Saturday night</td></tr>
            <tr><td>Where</td><td>St Kilda Town Hall</td></tr>
            <tr><td>Age Rating</td><td>MA18+</td></tr>
          </tbody>
        </table>
      </div>

      <div className='lr-padded-container center-text'>
        <p className='description'>
          The Collegium of the Winged Guard is an Epic D&D 5e adventure with an overarching storyline and player movement between tables as part of the game play. Players will need to make their own character using the guide sent to ticket holders.
        </p>
      </div>

      <div className='lr-padded-container center-text'>
        <p style={{marginBottom: '0.5rem'}}>Written by the amazing <strong>NephthysNile</strong></p>
        <p>Run by</p>
        <img src={masters_of_alchemy_img} alt='Masters of Alchemy' className='hero-img' />
      </div>
    </Wrapper>
  )
}
